
import Vue from "vue";
import { PriceFrequencyType } from "@/models/payment/pricing";
import { PaymentService } from "@/services/payment-service";
import { Mandat } from "@/models/payment/mandat";
import { Plan } from "@/utils/payments/plan";
import AppActivationCard from "@/components/account/ActivationCard.vue";
import { Tier } from "../../utils/payments/tiers";
import { HttpError } from "../../utils/services/http-error";
import { AuthService } from "../../services/auth-service";
import { CompanyService } from "../../services/company-service";
import AppBillingAddressEdit from "@/components/account/BillingAddressEditCard.vue";
import { BillingAddress } from "@/models/billing-address";
import { ComputedPricing } from "@/models/payment/computed-pricing";
import AppBillingAddress from "@/components/account/BillingAddressCard.vue";
import { PlanModulePricingFactory } from "@/utils/payments/plan-module-pricing-factory";

export default Vue.extend({
	data() {
		return {
			price: null as ComputedPricing | null,
			mandates: [] as Mandat[],
			plan: new Plan(),
			address: new BillingAddress(),
			editInvoiceAddress: false,
			ready: false,
			discountCode: "",
			AuthService
		};
	},
	computed: {
		mandate(): Mandat | null {
			if (this.mandates.length == 0) {
				return null;
			}
			return this.mandates[0];
		},
		hasBillingAddress(): boolean {
			return this.AuthService.wfCompany.WfOfflineID != "";
		}
	},
	watch: {
		plan: {
			deep: true,
			async handler() {
				this.fetchPrice();
			}
		}
	},
	methods: {
		async onBillingAddressUpdate(address:BillingAddress){
			this.address = address;
			this.editInvoiceAddress = false;
			this.mandates = await PaymentService.getMandates();
			this.fetchPrice();
		},
		async fetchPrice(){
			if (!this.ready) return;
			try {
				this.price = await PaymentService.getPriceOfPlan(this.plan, this.discountCode);
			} catch (err) {
				let error = err as HttpError;
				if (!error.isNetworkError) {
					let shouldCancel = true;
					if (error.key == "DISCOUNT_NOT_FOUND") {
						this.discountCode = "";
						this.fetchPrice();
						shouldCancel = false;
					}
					await this.$wf.dialog(error.getText(), this.$ct("common.ok"), this.$ct("common.error"), "warning");
					if (shouldCancel){
						this.$router.push("/account/price");
					}
				}
			}
		},
		onNewDiscountCode(code:string){
			this.discountCode = code;
			this.fetchPrice();
		}
	},
	async created() {
		this.plan.tier = parseInt(this.$route.query.tier as string) || Tier.STARTER;
		this.plan.paymentFrequency = PriceFrequencyType.YEAR;
		this.plan.modules = (JSON.parse(((this.$route.query.modules as string || "[]"))) as any[]).map((m: any) => PlanModulePricingFactory.create(m));
		this.discountCode = this.$route.query.discountCode as string || "";
		if (!this.hasBillingAddress){
			this.editInvoiceAddress = true;
			this.ready = true;
			return;
		}
		try {
			this.address = await CompanyService.getBillingAddress();
		} catch (err) {
			let e = err as HttpError;
			if (e.key == "ID_IS_NOT_VALID") {
				e.dontShow = true;
			}
		}
		this.mandates = await PaymentService.getMandates();
		this.ready = true;
		this.fetchPrice();
	},
	components: {
		//AppPaymentMethods,
		AppActivationCard,
		AppBillingAddressEdit,
		AppBillingAddress
	},
	i18nEx: {
		componentPrefix: "views.AccountActivate"
	},
});
